export default __webpack_public_path__ + "static/media/stake-more-ksm.825c2db1.svg";